import { ProfileImage } from "../model/ProfileImage";

export function getProfileImageUrl(profileImage: ProfileImage | undefined) {
  if(profileImage === undefined || profileImage.fileName === '') {
    return "/images/icon/no-image.svg";
  }

  return `${process.env.REACT_APP_IMAGE_URL}/${profileImage.fileName}`;
}